export default "__VITE_ASSET__Bg2PRqJZ__"